<template>
  <VTest :default-test="defaultTest" :test-diffs="testDiffs" :component="VPriceDetails" i18n="substore" />
</template>

<script>
import VTest from '@/components/Test';
import VPriceDetails from '@/components/Substore/PriceDetails';
import defaultTest from './default';
import testDiffs from './diffs';

export default {
  name: 'PricedetailsTest',

  components: {
    VTest,
  },

  data() {
    return {
      defaultTest,
      testDiffs,
      VPriceDetails,
    };
  },
};
</script>
